import Hero from '../component/Hero'
function Contact(){
    return(<>
            <Hero 
        cname= "Contact"
        heroImg = "https://cdn.pixabay.com/photo/2024/01/17/15/49/man-8514870_960_720.jpg"
        title = "Contact"        
        text = ""
        to = ''
    />
    </>)
}

export default Contact;